import { Organization, SubCategoryImage } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { ImageEntityConfig } from "./config";
import { ImageFilters } from "./filters";
import { ImageMethods } from "./methods";

@HyperEntity("image", ImageEntityConfig)
export class Image extends extender(ImageFilters, ImageMethods) {
  @Fields.uuid({ allowApiUpdate: false })
  id = "";

  @Fields.string({ dbName: "image_s3_key" })
  imageS3Key!: string;

  @Fields.boolean({ dbName: "is_background" })
  isBackground = false;

  @Fields.string({ dbName: "organization_id" })
  organizationId = "";

  @Relations.toOne(() => Organization, { field: "organizationId" })
  organization?: Organization;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();

  @Relations.toMany(() => SubCategoryImage, "imageId")
  subCategories: SubCategoryImage[] = [];
}
